import "@/App.css";
import { ReactLenis } from "lenis/react";
import { MotionConfig } from "framer-motion";
import Grain from "@/components/Grain";
import Hero from "@/components/Hero";
import MarqueeRibbon from "@/components/MarqueeRibbon";
import Manifesto from "@/components/Manifesto";
import StreamingLinks from "@/components/StreamingLinks";

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <ReactLenis root options={{ lerp: 0.08, smoothWheel: true, wheelMultiplier: 0.9 }}>
        <div
          className="App relative min-h-screen overflow-x-hidden bg-[#050505] text-[#e8e3d2]"
          data-testid="app-root"
        >
          <Grain />
          <main>
            <Hero />
            <MarqueeRibbon />
            <Manifesto />
            <StreamingLinks />
          </main>
          <footer
            data-testid="site-footer"
            className="border-t border-white/10 px-6 py-10 text-center"
          >
            <p className="font-accent text-[0.6rem] uppercase tracking-[0.35em] text-[#a39e8f]">
              Medieval Confessions
            </p>
            <p className="mt-3 text-xs text-[#5f5b52]">
              Every song is a confession. Every oath has a cost.
            </p>
          </footer>
        </div>
      </ReactLenis>
    </MotionConfig>
  );
}

export default App;
